import React from "react";
import Layout from "app/components/layouts";

import DeclarationSignaturesPartOne from "app/components/joint/signatures/DeclarationSignaturesPartOne";
import JointStepper from "app/components/common/JointStepper";

const JointSignatures: React.FC = () => {
  return (
    <>
      <Layout>
        <JointStepper />
        <DeclarationSignaturesPartOne />
      </Layout>
    </>
  );
};
export default JointSignatures;
